<template>
  <b-card>
    <b-card-header class="d-flex justify-content-between align-items-center">
      <h4 class="title mb-0">جزئیات قرارداد</h4>
      <div>
        <b-button :to="{ name: 'Contract_List' }" variant="outline-secondary" size="sm">بازگشت</b-button>
        <b-button v-if="isCreator" :to="{ name: 'Contract_Edit', params: { id: contract.id } }" variant="primary" size="sm">ویرایش</b-button>
      </div>
    </b-card-header>
    <b-card-body>
      <b-overlay :show="loading">
        <b-row v-if="contract.id">
          <b-col v-for="field in fields" :key="field.label" md="4" class="mb-2">
            <small class="text-muted d-block">{{ field.label }}</small>
            <strong :class="field.status ? statusClass : ''">{{ field.value }}</strong>
          </b-col>
        </b-row>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import { BButton, BCard, BCardBody, BCardHeader, BCol, BOverlay, BRow } from 'bootstrap-vue'

export default {
  name: 'ContractDetail',
  components: { BButton, BCard, BCardBody, BCardHeader, BCol, BOverlay, BRow },
  data() {
    return { loading: false, contract: {} }
  },
  computed: {
    fields() {
      return [
        { label: 'شناسه', value: this.contract.id || '-' },
        { label: 'نام قرارداد', value: this.contract.name || '-' },
        { label: 'نوع قرارداد', value: (this.contract.type && this.contract.type.title) || this.contract.type || '-' },
        { label: 'طرف قرارداد', value: this.contract.counterparty || '-' },
        { label: 'نوع طرف قرارداد', value: (this.contract.counterpartyType && this.contract.counterpartyType.title) || '-' },
        { label: 'تاریخ انقضا', value: this.contract.expirationDate || this.contract.expires_at || '-' },
        { label: 'ایجادکننده', value: (this.contract.creator && this.contract.creator.name) || '-' },
        { label: 'وضعیت', value: (this.contract.status && this.contract.status.title) || '-', status: true },
        { label: 'زمان باقی مانده', value: this.contract.remainingTime || this.remainingDays },
        { label: 'دوره یادآوری', value: `${this.contract.reminderLeadDays || 0} روز` },
      ]
    },
    remainingDays() {
      const days = this.contract.remainingDays
      if (days === 0) return 'امروز'
      if (days > 0) return `${days} روز`
      if (days < 0) return `${Math.abs(days)} روز گذشته`
      return '-'
    },
    isCreator() {
      const user = this.$store.state.user.data || {}
      return !!(user.id && this.contract.creator && user.id === this.contract.creator.id)
    },
    statusClass() {
      const status = this.contract.status && this.contract.status.key
      return { ACTIVE: 'text-success', NEAR_EXPIRATION: 'text-warning', EXPIRED: 'text-danger' }[status] || ''
    },
  },
  mounted() { this.getContract() },
  methods: {
    getContract() {
      this.loading = true
      this.$http.get(`contracts/${this.$route.params.id}`)
        .then(({ data }) => {
          const contract = data.contract || (data.data && (data.data.contract || data.data)) || (data.id ? data : null)
          if (!data.status || !contract) throw new Error(data.message || 'دریافت قرارداد با خطا مواجه شد.')
          this.contract = contract
        })
        .catch(error => this.$bvToast.toast((error.response && error.response.data && error.response.data.message) || error.message, {
          title: 'خطا در دریافت قرارداد', toaster: 'b-toaster-top-right', variant: 'danger',
        }))
        .finally(() => { this.loading = false })
    },
  },
}
</script>